import { createFileRoute } from '@tanstack/react-router'
import MetaLeadsPage from '@/pages/dashboard/meta-leads-page'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/meta-leads',
)({
  component: function MetaLeadsRoute() {
    return (
      <ProtectedRoute capability={CAPABILITIES.MANAGE_DASHBOARD_CONFIG}>
        <MetaLeadsPage />
      </ProtectedRoute>
    )
  },
})
